import { render, staticRenderFns } from "./owner-info.vue?vue&type=template&id=6a15b72a&"
import script from "./owner-info.vue?vue&type=script&lang=js&"
export * from "./owner-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports